var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageBenificary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3922_2676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.875 16.5H2.875C2.6 16.5 2.375 16.275 2.375 16V2C2.375 1.725 2.6 1.5 2.875 1.5H8.875V4.5C8.875 5.325 9.55 6 10.375 6H13.375V7.5C13.375 7.775 13.6 8 13.875 8C14.15 8 14.375 7.775 14.375 7.5V5.5C14.375 5.5 14.37 5.48 14.37 5.47C14.37 5.425 14.36 5.385 14.345 5.345C14.345 5.335 14.345 5.32 14.34 5.31C14.34 5.305 14.33 5.3 14.33 5.295C14.3073 5.24012 14.2732 5.19069 14.23 5.15L9.73 0.645C9.685 0.6 9.635 0.57 9.585 0.545C9.58 0.545 9.575 0.535 9.57 0.535C9.56 0.535 9.55 0.535 9.535 0.53C9.495 0.515 9.455 0.51 9.41 0.505C9.4 0.505 9.39 0.5 9.38 0.5H2.875C2.05 0.5 1.375 1.175 1.375 2V16C1.375 16.825 2.05 17.5 2.875 17.5H9.875C10.15 17.5 10.375 17.275 10.375 17C10.375 16.725 10.15 16.5 9.875 16.5ZM12.67 5H10.375C10.1 5 9.875 4.775 9.875 4.5V2.205L12.67 5ZM13.875 8.5C11.395 8.5 9.375 10.52 9.375 13C9.375 15.48 11.395 17.5 13.875 17.5C16.355 17.5 18.375 15.48 18.375 13C18.375 10.52 16.355 8.5 13.875 8.5ZM17.335 12.5H14.375V9.54C15.1215 9.64853 15.8129 9.99532 16.3463 10.5287C16.8797 11.0621 17.2265 11.7535 17.335 12.5ZM13.875 16.5C11.945 16.5 10.375 14.93 10.375 13C10.375 11.24 11.68 9.785 13.375 9.54V13C13.375 13.275 13.6 13.5 13.875 13.5H17.335C17.09 15.195 15.635 16.5 13.875 16.5ZM3.375 8C3.375 7.725 3.6 7.5 3.875 7.5H8.875C9.15 7.5 9.375 7.725 9.375 8C9.375 8.275 9.15 8.5 8.875 8.5H3.875C3.6 8.5 3.375 8.275 3.375 8ZM3.375 5.5C3.375 5.225 3.6 5 3.875 5H7.375C7.65 5 7.875 5.225 7.875 5.5C7.875 5.775 7.65 6 7.375 6H3.875C3.6 6 3.375 5.775 3.375 5.5Z",
    fill: "#717789"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3922_2676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageBenificary);
export default __webpack_public_path__ + "static/media/ManageBenificary.610cdc4819bb3354d00225590f6328d3.svg";
export { ForwardRef as ReactComponent };